import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import _ from "lodash";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const fmtMSS = (s) => (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;

const styles = (theme) => ({
  topLegent: {
    marginTop: 15,
    color: "rgba(0, 0, 0, 0.5)",
  },
  divider: {
    marginTop: 15,
    marginBottom: 10,
  },
  inputsContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  commonInputs: {
    width: "49%",
  },
  textSubCont: {
    width: "49%",
    display: "flex",
    alignItems: "center",
  },
});

@observer
class BulkSMSDialog extends Component {
  render() {
    const {
      isOpen,
      classes,
      handleClose,
      sendSMSBulk,
      bulkTextbox,
      timeInterval,
      setBulkMessage,
      setTimeInterval,
      bulkInProgress,
      totalBulkMessages,
      currentSendingAgent,
      totalBulkMessagesSent,
    } = this.props;

    return (
      <Dialog
        {...{
          fullWidth: true,
          keepMounted: true,
          maxWidth: "sm",
          open: isOpen,
          TransitionComponent: Transition,
          onClose: handleClose,
        }}
      >
        <DialogTitle id="alert-dialog-slide-title">SEND BULK SMS</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div>
              <Typography className={classes.topLegent}>
                Time remaining:{" "}
                {fmtMSS(
                  (totalBulkMessages - totalBulkMessagesSent) * timeInterval
                )}{" "}
                - This operation will take a while, do not close this window or
                browser.
              </Typography>
              <Divider variant="fullWidth" className={classes.divider} />
            </div>
            <div className={classes.inputsContainer}>
              <TextField
                id="formatted-text-mask-input-phone"
                label="Time interval"
                margin="normal"
                variant="outlined"
                className={classes.commonInputs}
                onChange={(evt) => {
                  setTimeInterval(evt.target.value);
                }}
                value={timeInterval}
                InputProps={{
                  readOnly: true,
                }}
              />
              <div className={classes.textSubCont}>
                <Typography>
                  {totalBulkMessagesSent !== totalBulkMessages && "Sending "}
                  {totalBulkMessagesSent} of {totalBulkMessages}
                  {totalBulkMessagesSent !== totalBulkMessages
                    ? ` to ${currentSendingAgent}`
                    : " completed!"}
                </Typography>
              </div>
            </div>
            <TextField
              id="outlined-multiline-static"
              label="Your message..."
              multiline
              rows="4"
              fullWidth={true}
              margin="normal"
              variant="outlined"
              value={bulkTextbox}
              onChange={(evt) => setBulkMessage(evt.target.value)}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose()} color="primary">
            CLOSE
          </Button>
          <Button
            disabled={bulkTextbox === "" || timeInterval < 0 || bulkInProgress}
            onClick={() => {
              sendSMSBulk();
            }}
            color="primary"
          >
            SEND
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

BulkSMSDialog.propTypes = {
  isOpen: PropTypes.func,
  handleClose: PropTypes.func,
  sendSMS: PropTypes.func,
  setBulkMessage: PropTypes.func,
};

export default withStyles(styles)(BulkSMSDialog);
